/* Toggle flashlight options for style stix based on metafield guru property.
* Usage: snippets/product-page-get-info-clear-stix.liquid
*/
document.addEventListener("DOMContentLoaded", function () {;
  //alert("loaded2")
  const variantSKU = document.querySelector("[data-js-variant-sku]");

  if (!variantSKU) {
  console.log( "Can't found variantSKU element for hidding flashlight options");
   return;
  }

  //console.log(variantSKU)


  // Options for the observer (which mutations to observe)
  const configVariant = { attributes: true, childList: true, subtree: true };

  // Callback function to execute when mutations are observed
  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      //console.log(mutation.target.innerText)
      //alert(mutation.target.innerText)

      if (mutation.type === "childList") {
        const {target} = mutation 
        const sku = target.innerText
        const metafieldSKU = variantMetafieldGuruData[sku]
        console.log(metafieldSKU)
        const container = document.querySelector(".additional_products__items")
        const message = document.querySelector("[data-js-no-lightup-feature-msg]")
        
        if(metafieldSKU === '1'){
         container.classList.add('hide')
          message.classList.remove('hide')
        }else{
          container?.classList?.remove('hide')
          message?.classList?.add('hide')
        }
    } 
     

    }
  };

  // Create an observer instance linked to the callback function
  const observer = new MutationObserver(callback);

  // Start observing the target node for configured mutations
  observer.observe(variantSKU, configVariant);
})
